import React, { Component } from 'react';
import classNames from 'classnames';
import RenderInBody from 'components/shared/render_in_body';
import ModalContainer from 'components/shared/modal/modal_container';
import { Icon } from 'ui';
import { SavedElementTypes } from 'constants/savedElements.js';
import SavedElementTypeSelection from './SavedElementTypeSelection';

class SaveContentModal extends Component {
  constructor(props) {
    super(props);

    let initialSavedElementType = SavedElementTypes.Template;
    if (props.isEnabledLinkedElement) {
      initialSavedElementType = null;
    }

    this.initialState = {
      savedElementType: initialSavedElementType,
      title: '',
      description: '',
      error: false,
    };

    this.state = this.initialState;
    this.onSave = this.onSave.bind(this);
    this.handleTitleChange = this.handleTitleChange.bind(this);
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
  }

  onSave() {
    const params = {
      title: this.state.title,
      description: this.state.description,
      type: this.state.savedElementType,
    };

    this.props
      .onSave(params, this.props.savePath)
      .then(data => {
        this.props.showSavedContentNotification(data);
        if (data && data.element) {
          this.props.replaceElement(data.element);
        }
        this.props.dismissCallback();
      })
      .catch(e => {
        console.error(e);
        this.handleError();
      });
  }

  handleTitleChange(e) {
    this.setState({ title: e.target.value });
  }

  handleDescriptionChange(e) {
    this.setState({ description: e.target.value });
  }

  handleError() {
    this.setState({ error: true });
  }

  renderBody() {
    const inputClassName = 'NewInput NewInput--white NewInput--fw mt-8';
    const canSubmit = !!(this.state.title && this.state.savedElementType);

    const buttonClassName = classNames('NewButton', {
      'NewButton--small': true,
      'NewButton--center': true,
      'NewButton--blue': true,
      'Modal-button': true,
      'SaveContentModal-button': true,
      'NewButton--disabled': this.state.disabled,
    });

    return (
      <div className="SaveContentModal-body">
        <div className="SaveContentModal-directions">
          <div className="SaveContentModal-header">
            {t('saved_content.title.header')}
          </div>
          <div className="SaveContentModal-description">
            {t('saved_content.overview')}
          </div>
        </div>
        <div className="SaveContentModal-input">
          <div className="SaveContentModal-titleInput">
            {t('saved_content.title.name')}
            <input
              className={inputClassName}
              type="text"
              onChange={this.handleTitleChange}
              placeholder={t('saved_content.placeholder.name')}
            />
          </div>
          {this.props.isEnabledLinkedElement && (
            <div className="SaveContentModal-elementTypeInput">
              {t('saved_content.title.element_type')}
              <SavedElementTypeSelection
                type={this.state.savedElementType}
                onChange={e => {
                  this.setState({ savedElementType: e.target.value });
                }}
              />
            </div>
          )}
          <div className="SaveContentModal-descriptionInput">
            {t('saved_content.title.description')}
            <textarea
              className={inputClassName}
              onChange={this.handleDescriptionChange}
              placeholder={t('saved_content.placeholder.description')}
            />
          </div>
        </div>
        {this.state.error && (
          <div className="ErrorContainer SaveContentModal-errorMessage p-4 mb-16">
            {t('saved_content.error.on_save')}
          </div>
        )}
        <div className="SaveContentModal--actions d-f ai-c jc-e">
          {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/anchor-is-valid */}
          <span
            role="button"
            tabIndex={0}
            className="c-p c-brand-gray-darker mr-24 h-td-u"
            type="cancel"
            onClick={this.props.onCancel}
          >
            {t('saved_content.button.cancel')}
          </span>
          <button
            type="submit"
            className={buttonClassName}
            onClick={this.onSave}
            disabled={!canSubmit}
          >
            {t('saved_content.button.save')}
          </button>
        </div>
      </div>
    );
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!nextProps.show) {
      this.setState(this.initialState);
    }
  }

  render() {
    if (!this.props.show) return false;

    return (
      <RenderInBody>
        <ModalContainer
          onEscape={this.props.dismissCallback}
          className="SaveContentModal Modal-background"
        >
          <div className="Modal-container SaveContentModal-container">
            <div
              className="ModalTakeover-closeButton"
              onClick={this.props.dismissCallback}
              onKeyDown={e => e.key === 'Enter' && this.props.dismissCallback()}
            >
              <Icon name="remove" />
            </div>
            {this.renderBody()}
          </div>
        </ModalContainer>
      </RenderInBody>
    );
  }
}

export default props => {
  const isEnabledLinkedElement = props.type?.toLowerCase() === 'paragraph';

  return (
    <SaveContentModal
      isEnabledLinkedElement={isEnabledLinkedElement}
      {...props}
    />
  );
};
